import React from 'react'

import {
    AdminPage, TabBar, Toolbar,
    Box, Button, LinkButton
} from '../components'

import BlacklistEdit from '../forms/BlacklistEdit'
import {Http, i18n} from 'common'

const SCOPE_ALL = 'all'
const SCOPE_WHITELIST = 'whitelist'
const SCOPE_BLACKLIST = 'blacklist'


export default class Clients extends React.Component {
    state = {
        scope: SCOPE_ALL,
        url: 'api/clients'
    }

    tabs = [
        ['all', i18n('manage-clients.tab.show-all')],
        ['whitelist', i18n('manage-clients.tab.whitelist')],
        ['blacklist', i18n('manage-clients.tab.blacklist')]
    ]

    onScopeChange = (value) => {
        this.setState({scope: value})
    }

    render() {
        return (
            <div>
                <TabBar
                    buttons={this.tabs}
                    onChange={this.onScopeChange}
                />

                <Box>
                    {this.state.scope === SCOPE_ALL && <ScopeAll /> }
                    {this.state.scope === SCOPE_WHITELIST && <ScopeWhitelist /> }
                    {this.state.scope === SCOPE_BLACKLIST && <ScopeBlacklist /> }
                </Box>
            </div>
        )
    }
}

class ScopeAll extends AdminPage {
    whiteListUrl = (config, item) => {
        let whitelist = null
        let whitelistClass = 'dimmed-button'
        let whitelistUrl = `/clients/${item.id}/whitelists/new`

        whitelist = config.whitelistByClient(item)
        if (whitelist != null) {
            whitelistUrl = `/clients/${item.id}/whitelists/${whitelist.id}`
            whitelistClass = ''
        }

        return { url: whitelistUrl, class: whitelistClass }
    }

    handleFilter = (value = '', items) => (
        items.filter(item => {
            const {clientName = '', clientId = ''} = item
            const safeClientName = clientName.toLowerCase()
            const safeClientId = clientId.toLowerCase()
            const safeValue = value.toLowerCase()

            return (safeClientName.includes(safeValue) || safeClientId.includes(safeValue))
        })
    )

    config = {
        url: 'api/clients',
        addButton: {title: i18n('manage-clients.new'), url: 'clients/new'},
        layout: 'none',
        filter: this.handleFilter,
        sortBy: (i, j) => (new Date(j.createdAt) - new Date(i.createdAt)),
        columns: [
            {type: 'fold'},
            {type: 'string', title: i18n('manage-clients.all.client-name'), className: 'table-200p', getter: 'clientName'},
            {type: 'list', title: i18n('manage-clients.all.redirect-uri'), getter: 'redirectUris'},
            {type: 'string', title: i18n('manage-clients.all.client-id'), getter: 'clientId' },
            {type: 'tag-list', title: i18n('manage-clients.all.scope'), getter: 'scope'},
            {type: 'date', title: i18n('manage-clients.all.registered-on'), getter: 'createdAt'},
            {type: 'actions', allows: {'Edit': '/clients/', 'Whitelist': this.whiteListUrl, 'Delete': 'api/clients/'}, className: 'table-150p'}
        ]
    }
}

class ScopeWhitelist extends AdminPage {
    editUrl = (config, item) => {
        if (item.relationId === null) {
            return ''
        }

        return {url: `/clients/${item.relationId}/whitelists/${item.id}`}
    }

    config = {
        url: 'api/whitelist',
        layout: 'none',
        columns: [
            {type: 'fold'},
            {type: 'string', title: i18n('manage-clients.whitelist.client-name'), className: 'table-200p', getter: 'clientName'},
            {type: 'string', title: i18n('manage-clients.whitelist.client-id'), className: 'table-200p', getter: 'clientId'},
            {type: 'tag-list', title: i18n('manage-clients.whitelist.scope'), getter: 'allowedScopes'},
            {type: 'actions', allows: {'Edit': this.editUrl, 'Delete': 'api/whitelist/'}, className: 'table-100p'}
        ]
    }

    onCompleteLoad = (data) => {
        Http.GET('api/clients', (data) => {
            const {items} = this.state

            for (let i of items) {
                const client = data.find(j => j.clientId === i.clientId);
                if (client != null) {
                    i.clientName = client.clientName;
                    i.relationId = client.id;
                }
            }


            this.setState({items: items})
        })
    }
}

class ScopeBlacklist extends AdminPage {
    config = {
        url: 'api/blacklist',
        layout: 'none',
        columns: [
            {type: 'string', title: i18n('manage-clients.blacklist.uri'), getter: 'uri'},
            {type: 'actions', allows: {'Delete': 'api/blacklist/'}, className: 'table-70p'}
        ]
    }

    onRenderToolbar = () => (
        <BlacklistEdit onChange={() => this.onReload()} />
    )
}
